module.exports = __webpack_public_path__ + "static/media/Nguyen_Phi_Le.7f3eb8bd.jpg";